const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', 'hub.localhost']);

/** Whether a postMessage came from the Hub embedding this portal: localhost in development, or hub.* for this connect.* host. */
export function isTrustedHubOrigin(origin: string, location: Pick<Location, 'protocol' | 'host'> = window.location): boolean {
  let hostname: string;
  try {
    hostname = new URL(origin).hostname;
  } catch {
    return false;
  }
  return LOCAL_HOSTS.has(hostname) || origin === `${location.protocol}//${location.host.replace(/^connect\./, 'hub.')}`;
}
